import { z } from 'zod';
import type { TFunction } from 'i18next';
import { MEMBER_ROLES } from '@/core/constants/roles';

export const createInviteMemberSchema = (t: TFunction) =>
  z.object({
    email: z.email({ error: t('members:errors.emailInvalid') }),
    role: z.enum(MEMBER_ROLES, {
      message: t('members:errors.roleRequired'),
    }),
    expiresAt: z.string().nullable().optional(),
  });

export type InviteFormValues = z.infer<ReturnType<typeof createInviteMemberSchema>>;
